import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-close.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-46fe15aa")

_pushScopeId("data-v-46fe15aa")
const _hoisted_1 = { class: "pantry-search-tag-item-view" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-search-tag-item-close-icon",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "pantry-search-tag-item",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("img", {
        class: "pantry-search-tag-item-icon",
        src: _ctx.getIcon()
      }, null, 8, ["src"]), [
        [_vShow, _ctx.isShowIcon()]
      ]),
      _withDirectives(_createVNode("div", { class: "commonTextCaption2 pantry-search-tag-item-label" }, _toDisplayString(_ctx.getName()), 513), [
        [_vShow, !_ctx.isShowIcon()]
      ]),
      _hoisted_2
    ])
  ]))
})